import React, { useState } from "react";
import { Link } from "react-router-dom";

import { ContentPad, ContentViewport, SinglePanel } from "../../app/app-layout";
import { NavTab, TabContainer, TabContent, TabPanel } from "../../components/nav-tabs/nav-tabs";
import { getHubPlatforms, getHubTrainingPlatforms, HubPlatform } from "../../data/hub-platforms";
import { PlatformCard } from "./platform-card";

type HubTabId = "platforms" | "training";

const PlatformGrid: React.FC<{ platforms: HubPlatform[] }> = ({ platforms }) => (
  <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4 g-3 hub-platform-grid">
    {platforms.map(platform => (
      <PlatformCard key={platform.id} platform={platform} />
    ))}
  </div>
);

export const HubScreen: React.FC = () => {
  const [activeTab, setActiveTab] = useState<HubTabId>("platforms");

  return (
    <ContentViewport>
      <SinglePanel>
        <ContentPad>
          <TabContainer className="hub-tabs">
            <NavTab
              href="#hub-platforms"
              isActive={activeTab === "platforms"}
              onClick={() => setActiveTab("platforms")}
            >
              <span className="fas fa-table-cells-large icon" aria-hidden="true"></span>
              Platforms
            </NavTab>
            <NavTab href="#hub-training" isActive={activeTab === "training"} onClick={() => setActiveTab("training")}>
              <span className="fas fa-graduation-cap icon" aria-hidden="true"></span>
              Training
            </NavTab>
          </TabContainer>
          <TabContent>
            <TabPanel id="hub-platforms" isActive={activeTab === "platforms"} isCard={true}>
              <div className="card-header hub-panel-header">
                <h2 className="h1">Platforms</h2>
              </div>
              <p>
                Click a platform name to navigate to that platform. Permissions can be granted on the{" "}
                <Link to="/staff-administration">Staff</Link> tab.
              </p>
              <PlatformGrid platforms={getHubPlatforms()} />
            </TabPanel>
            <TabPanel id="hub-training" isActive={activeTab === "training"} isCard={true}>
              <div className="card-header hub-panel-header">
                <h2 className="h1">Training</h2>
              </div>
              <p>
                Click a platform name to navigate to that platform. <strong>Training</strong> platforms can be used to{" "}
                <strong>practice</strong> and <strong>train</strong> staff. Any data you add/change in training will not
                impact your real students.
              </p>
              <PlatformGrid platforms={getHubTrainingPlatforms()} />
            </TabPanel>
          </TabContent>
        </ContentPad>
      </SinglePanel>
    </ContentViewport>
  );
};

export const hubLoader = () => {
  return {
    activeTab: "Huntington Hub",
    tabQualifier: undefined
  };
};
